import { useAuth, RedirectToSignIn } from "@clerk/react";
import { ReactNode } from "react";
import Spinner from "./spinner/Spinner";

interface ProtectedRouteProps {
  children: ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { isLoaded, isSignedIn } = useAuth();

  if (!isLoaded) {
    return (
      <div className="flex min-h-[200px] items-center justify-center">
        <Spinner size={48} label="" inline={false} />
      </div>
    );
  }

  if (!isSignedIn) {
    return <RedirectToSignIn />;
  }

  return <>{children}</>;
};
